import './styles.scss';

const DashedDivider = () => {
  return <div className="dashed-divider" />;
};
export default DashedDivider;
